export default __webpack_public_path__ + "static/subset-UniNeueBook-13609348f177b6ba4154ce65d90807a6.woff2";